export default {
  exportData: (state) => state.exportData,
  loading: (state) => state.loading
}
